"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextCell = void 0;
const react_1 = __importStar(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const tooltip_1 = require("../../tooltip/tooltip");
const table_field_styles_1 = require("../table-field-styles");
const component_size_1 = require("../../../utils/component-size");
const lib_1 = require("use-debounce/lib");
exports.TextCell = react_1.memo(function TextCell({ value, }) {
    const classes = table_field_styles_1.useStyles();
    const textRef = react_1.useRef(null);
    const [useTooltip, setUseTooltip] = react_1.useState(false);
    const { width } = component_size_1.useComponentSize(textRef);
    const [debouncedWidth] = lib_1.useDebounce(width, 500);
    react_1.useLayoutEffect(() => {
        setUseTooltip(isEllipsisActive(textRef));
    }, [value, debouncedWidth]);
    const content = (react_1.default.createElement(Typography_1.default, { className: classes.tableCell, ref: textRef }, value));
    return useTooltip ? (react_1.default.createElement(tooltip_1.Tooltip, { title: value, placement: "top-start", type: "HOVER" }, content)) : (react_1.default.createElement(react_1.default.Fragment, null, content));
});
function isEllipsisActive(e) {
    const current = e.current;
    return current !== null ? current.offsetWidth < current.scrollWidth : false;
}
//# sourceMappingURL=text-cell.js.map